export const hasPremiseAvailability = (deals) => {
  const dealsArray = Array.isArray(deals) ? deals : [deals]
  return dealsArray.some((deal) => deal.availability === 'premise')
}
